export class ScheduledEvent {

  session: string;
  possibleDate: string;
  eventType: string;
  itzName: string;
  creationUser: string;
  label: string;
  purpose: string;
  status: string;
  highlighted: boolean;
  participation: string;
  valitatedCount: number;
  refusedCount: number;
  pendingCount: number;

  constructor() {
    this.session = "";
    this.possibleDate = "";
    this.eventType = "";
    this.creationUser = "" ;
    this.itzName = "";
    this.label = "";
    this.purpose = "";
    this.highlighted = false;
    this.valitatedCount = 0;
    this.refusedCount = 0;
    this.pendingCount = 0;
  }
}
